//  filepath: src/components/dashboard/LegendPills.jsx
export default function LegendPills({ monthNow, monthPrev }) {
  return (
    <div className="flex items-center gap-6 px-2 pb-2 text-sm">
      <div className="flex items-center gap-2 text-gray-500">
        <span
          className="inline-block h-2.5 w-2.5 rounded-full"
          style={{ background: "#94a3b8" }}
        />
        <span>{monthPrev}</span>
      </div>
      <div className="flex items-center gap-2 text-gray-700">
        <span
          className="inline-block h-2.5 w-2.5 rounded-full"
          style={{ background: "#2563eb" }}
        />
        <span>{monthNow}</span>
      </div>
    </div>
  );
}
